import { render, staticRenderFns } from "./site-treaty.vue?vue&type=template&id=fd380b3e&"
import script from "./site-treaty.vue?vue&type=script&lang=js&"
export * from "./site-treaty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports